import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Cookies from "js-cookie";
import { selectMailer } from "./helpers";
import styles from "./styles/popupMailer.module.css";

const PopupMailer = ({ popupMailers, ...props }) => {
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [activeMailer, setActiveMailer] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  
  // Set active mailer when popupMailers prop changes
  useEffect(async () => {

    if (popupMailers && popupMailers.length > 0) {
      const currentPath = window.location.pathname;
      const selectedMailer = selectMailer(popupMailers, currentPath);
      setActiveMailer(selectedMailer);
    }
  }, [popupMailers]);

  useEffect(() => {
    setTimeout(() => {
      showPopup();
      document.body.style.overflow = 'hidden';
    },2000)
  },[activeMailer])

  // Check if popup should be shown based on targeting rules
  // const checkTargetingRules = (targeting) => {
  //   if (!targeting || !targeting.showBy) return true;

  //   return targeting.showBy.every(condition => {
  //     switch (condition.type) {
  //       case 'exitIntent':
  //         // Exit intent logic would go here
  //         return true;
  //       case 'delay':
  //         // Delay is handled by the main useEffect
  //         return true;
  //       case 'urlPattern':
  //         if (condition.value) {
  //           try {
  //             const regex = new RegExp(condition.value);
  //             return regex.test(window.location.pathname);
  //           } catch (error) {
  //             console.error('Invalid regex pattern:', condition.value);
  //             return false;
  //           }
  //         }
  //         return true;
  //       case 'visitorType':
  //         if (condition.visitorType === 'new') {
  //             return !Cookies.get('returning_visitor');
  //           } else if (condition.visitorType === 'returning') {
  //             return Cookies.get('returning_visitor');
  //           }
  //           return true;
  //       case 'pageCount':
  //         const pageCount = parseInt(Cookies.get('page_count') || '0');
  //         return pageCount >= parseInt(condition.value || '1');
  //       case 'visitCount':
  //         const visitCount = parseInt(Cookies.get('visit_count') || '0');
  //         return visitCount >= parseInt(condition.value || '1');
  //       default:
  //         return true;
  //     }
  //   });
  // };


  // Show popup if conditions are met
  const showPopup = () => {

    if (!activeMailer) return false;
    
    const shouldShow =  true; //checkTargetingRules(activeMailer.targeting);
    if (shouldShow) {
      // Check if popup was recently closed
      const recentlyClosed = Cookies.get(`popup_closed_${activeMailer._id}`);
      if (recentlyClosed) return false;
      setIsVisible(true);
      
      return true;
    }
    
    return false;
  };

  // Hide popup
  const hidePopup = () => {
    setIsVisible(false);
    
    if (activeMailer?.behavior?.closeOnOverlayClick) {
      // Set cookie to prevent showing again for a while
      Cookies.set(`popup_closed_${activeMailer._id}`, 'true', { expires: 3 });
       document.body.style.overflow = 'unset';
    }
  };

  const handleClose = () => {
    hidePopup();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || isLoading) return;

    setIsLoading(true);
    setError(null);

    console.log('SUBMIT', {
      email,
      newsletter: activeMailer.content.klaviyoListId,
      form: "popup_mailer",
      formSource: activeMailer.title
    })
    
    try {
      // Submit to Klaviyo
      const response = await fetch("/api/klaviyo-subscribe", {
        method: "POST",
        headers: { 
          "Content-Type": "application/json" 
        },
        body: JSON.stringify({
          email,
          newsletter: activeMailer.content.klaviyoListId,
          form: "popup_mailer",
          formSource: activeMailer.title
        }),
      });

      if (response.ok) {
        setIsSubmitted(true);
        
        // Hide popup after success message
        setTimeout(() => {
          hidePopup();
        }, 3000);
      } else {
        console.error('Failed to subscribe');
        setError('Unable to subscribe. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setError('Unable to subscribe. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape' && activeMailer?.behavior?.closeOnEscape) {
      handleClose();
    }
  };

  if (!activeMailer || !isVisible) return null;

  const { content, design = {}, behavior = {} } = activeMailer;

  const { 
    leftImage,
    heading,
    description,
    emailPlaceholder = "Enter your email address",
    buttonText = "Join in",
    successMessage = "Thank you for subscribing!"
  } = content || {};

  console.log('LEFT', leftImage)

  const {
    backgroundColor = "#ffffff",
    textColor = "#000000",
    buttonColor = "#000000",
    buttonTextColor = "#ffffff",
    popupType = "modal",
    size = "medium",
    position = "center"
  } = design || {};

  const {
    animation = "fadeIn",
    animationDuration = 300,
    preventScroll = true
  } = behavior || {};


  const popupStyles = {
    backgroundColor,
    color: textColor,
    animation: `${animation} ${animationDuration}ms ease-out`,
  };

  const buttonStyles = {
    backgroundColor: buttonColor,
    color: buttonTextColor,
  };

  const sizeClass = size === 'small' ? styles.small : size === 'large' ? styles.large : styles.medium;
  const positionClass = styles[position] || styles.center;

  return (
    <div 
      className={styles.overlay} 
      onClick={behavior.closeOnOverlayClick ? handleClose : undefined}
      onKeyDown={handleKeyDown}
      tabIndex={-1}
    >
      <div 
        className={`${styles.popup} ${sizeClass} ${positionClass}`}
        style={popupStyles}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button 
          className={styles.closeButton}
          onClick={handleClose}
          aria-label="Close popup"
        >
          ×
        </button>

        <div className={styles.content}>
          {/* Left Side - Image */}
          {leftImage && (
            <div className={styles.imageSection}>
              <img 
                src={leftImage.asset.url}
                alt={leftImage?.altText || "Popup image"}
                className={styles.image}
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </div>
          )}

          {/* Right Side - Content */}
          <div className={styles.textSection}>
            <h2 className={styles.heading}>
              {heading || "Join the Kotn Community!"}
            </h2>
            <p className={styles.description}>
              {description || "Get 10% off your purchase as a thank you for staying in touch."}
            </p>
            
            {!isSubmitted ? (
              <form onSubmit={handleSubmit} className={styles.form}>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={emailPlaceholder}
                  required
                  className={styles.emailInput}
                  disabled={isLoading}
                />
                <button 
                  type="submit" 
                  className={styles.submitButton}
                  style={buttonStyles}
                  disabled={isLoading}
                >
                  {isLoading ? "Subscribing..." : error ? "Try Again" : buttonText}
                </button>
                
                {/* Error Message */}
                {error && (
                  <div className={styles.errorMessage}>
                    {error}
                  </div>
                )}
              </form>
            ) : (
              <div className={styles.successMessage}>
                {successMessage}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

PopupMailer.propTypes = {
  popupMailers: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      isActive: PropTypes.bool.isRequired,
      content: PropTypes.object,
      design: PropTypes.object,
      behavior: PropTypes.object,
      targeting: PropTypes.object,
    })
  ),
};

export default PopupMailer;
